import api from "@/services/api";
import { ENDPOINTS } from "@/constants/endpoints";

const STATUS = {
  loggedIn: "success",
  error: "error",
  logging: "logging",
};

const auth = {
  namespaced: true,

  state: {
    status: null,
    session: null,
    sessionRequestDone: false,
  },

  getters: {
    isAuthenticated: (state) => state.status === STATUS.loggedIn,
    status: (state) => state.status,
    session: (state) => state.session,
    sessionRequestDone: (state) => state.sessionRequestDone,
  },

  mutations: {
    sessionRequestDone(state, boolean) {
      state.sessionRequestDone = boolean;
    },
    session(state, boolean) {
      state.session = boolean;
    },
    logging(state) {
      state.status = STATUS.logging;
    },
    login(state) {
      state.status = STATUS.loggedIn;
    },
    error(state) {
      state.status = STATUS.error;
    },
    logout(state) {
      state.status = null;
    },
  },

  actions: {
    async login({ commit, dispatch }) {
      commit("logging");

      try {
        await dispatch("user/fetch", null, { root: true });
        await dispatch("user/termsAcceptTime", null, { root: true });
        commit("login");
      } catch (err) {
        commit("error", err);
      }
    },
    logout: ({ commit }) => {
      commit("logout");
    },

    async initSession({ commit, dispatch }) {
      commit("logging");
      try {
        await dispatch("user/fetch", null, { root: true });
        await dispatch("user/termsAcceptTime", null, { root: true });
        commit("login");
      } catch (err) {
        commit("error", err);
      }
    },

    hasPrivilege({ rootGetters }, privilege) {
      const privileges = rootGetters["user/privileges"];
      return !!privileges.find(({ key }) => key === privilege);
    },
    hasCorrectRoleType({ rootGetters }, type) {
      const roleType = rootGetters["user/activeRoleType"];
      return type.includes(roleType);
    },

    async checkSession({ commit }) {
      try {
        await api.get(ENDPOINTS.auth_session);
        commit("session", true);
      } catch (e) {
        commit("session", false);
      } finally {
        commit("sessionRequestDone", true);
      }
    },
  },
};

export default auth;
